import { useEffect, useMemo } from 'react'
import { Navigate, Route, Routes, useLocation, useNavigate } from 'react-router-dom'
import Header from './components/Header'
import Footer from './components/Footer'
import StarfieldBg from './components/StarfieldBg'
import HomePage from './pages/HomePage'
import NossosServicosPage from './pages/NossosServicosPage'
import PoliticaPrivacidadePage from './pages/PoliticaPrivacidadePage'
import { LEAD_BOOSTER_HREF } from './integrations/leadBooster'
import type { NavLinkItem } from './types/site'

function scrollToTop() {
  if (window.__lenis) {
    window.__lenis.scrollTo(0, { immediate: true })
  } else {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' })
  }
}

export default function App() {
  const location = useLocation()
  const navigate = useNavigate()
  const isInnerPage =
    location.pathname === '/nossos-servicos' || location.pathname === '/politica-de-privacidade'

  useEffect(() => {
    scrollToTop()
  }, [location.pathname])

  const navLinks = useMemo<NavLinkItem[]>(() => {
    if (isInnerPage) {
      return [
        { label: 'Início', href: '/' },
        { label: 'Nossos Serviços', href: '/nossos-servicos' },
      ]
    }

    return [
      { label: 'Início', href: '/' },
      { label: 'Nossos Serviços', href: '/nossos-servicos' },
      { label: 'Metodologia', href: '#metodo' },
      { label: 'Quem Somos', href: '#quem-somos' },
      { label: 'Infraestrutura Ativa', href: '#projetos' },
      { label: 'Perguntas Frequentes', href: '#faq' },
    ]
  }, [isInnerPage])

  const footerLinks = useMemo<NavLinkItem[]>(() => {
    if (isInnerPage) {
      return [
        { label: 'Início', href: '/' },
        { label: 'Nossos Serviços', href: '/nossos-servicos' },
        { label: 'Contato', href: LEAD_BOOSTER_HREF },
      ]
    }

    return [
      { label: 'Início', href: '/' },
      { label: 'Metodologia', href: '#metodo' },
      { label: 'Quem Somos', href: '#quem-somos' },
      { label: 'Infraestrutura Ativa', href: '#projetos' },
      { label: 'Perguntas Frequentes', href: '#faq' },
    ]
  }, [isInnerPage])

  return (
    <div className="relative min-h-screen text-text-main">
      <StarfieldBg />
      <Header navLinks={navLinks} onNavigate={navigate} currentPath={location.pathname} />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/nossos-servicos" element={<NossosServicosPage />} />
        <Route path="/politica-de-privacidade" element={<PoliticaPrivacidadePage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      <Footer key={location.pathname} navLinks={footerLinks} onNavigate={navigate} currentPath={location.pathname} />
    </div>
  )
}
